<main class="main">
  <section class="content">
    <router-outlet></router-outlet>
  </section>
</main>
